<template>
  <div class="pfslide" style="margin-bottom: 5px">
    <div class="pfslide__title" v-html="title"></div>
    <div class="pfslide__thincontent">
        <div class="pfslidepsflex pfslidepsflex_alt">
            <TextInput class="pfslidepsflex__first" text='Город, улица, дом' name='address' v-model="client.object.address.text" :options="addressSuggest" :forceError="addressValidation" :blurcondition="!addressValidation"/>
            <NumberInput class="pfslidepsflex__last" v-if="!noflat" v-model="this.client.object.address.flat" text='Квартира' name='address-flat' :mask="'#*'"/>
        </div>
        <div class="pfslide__map">
            <Transition name="slowfade">
                <div v-show="mapshown" id="map"></div>
            </Transition>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import slide from '../../mixins/slide.vue'
import TextInput from '../inputs/TextInput.vue'
import NumberInput from '../inputs/NumberInput.vue'
  export default {
    name: "slide2",
    mixins: [slide],
    data: () => ({
        addressSuggest: [],
        suggestionsData: [],
        mapshown: false
    }),
    mounted(){
        // eslint-disable-next-line
        let init = ()=>{ 
            // eslint-disable-next-line 
            window.map = new ymaps.Map("map", {
                center: [55.76, 37.64],
                zoom: 7,
                controls: []
            }, { suppressMapOpenBlock: true})
        }
        window.ymaps.ready(init)
    },
    methods: {
        setMap(coords){
            if (window.placemark)
                window.map.geoObjects.remove(window.placemark)
            window.map.setCenter(coords,15)
            // eslint-disable-next-line
            window.placemark = new ymaps.Placemark(coords, {}, {
                preset: "islands#redDotIcon",
                iconColor: '#ff0000'
            });
            window.map.geoObjects.add(window.placemark);
        },
        applyAddress(val) {
            this.client.object.address.city_kladr_id = "";
            this.client.object.address.street_kladr_id = "";
            this.client.object.address.house_kladr_id = "";
            this.client.object.address.index = "";
            this.client.object.address.house = "";
            if (val && this.suggestionsData) {
                let found = this.suggestionsData.find(el => el.value == val);
                if (!found)
                    return this.mapshown = false;
                this.client.object.address.city_kladr_id = found.data.city_kladr_id || found.data.settlement_kladr_id;
                this.client.object.address.street_kladr_id = found.data.street_kladr_id;
                this.client.object.address.house_kladr_id = found.data.house_kladr_id;
                this.client.object.address.house = found.data.house;
                this.client.object.address.index = found.data.postal_code;
                if (found.data.geo_lat && found.data.geo_lon) {
                    this.setMap([found.data.geo_lat, found.data.geo_lon])
                    this.mapshown = true
                } else this.mapshown = false
            } else this.mapshown = false
        },
        async suggestAddress(query) {
            let url = this.DaData.urls.address, token = this.DaData.token, options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({ query: query, count: 5, "locations": [{ "country": "Россия" }], "to_bound": { "value": "house" }})
            };
            let sg = await (fetch(url, options)
                .then(response => response.json())
                .then(res => res.suggestions.filter(el => el.data))
                .catch(() => []));
            this.suggestionsData = sg;
            this.addressSuggest = sg.map(el => el.value);
        }
    },
    watch: {
        async "client.object.address.text"(val) {
            await this.suggestAddress(val);
            this.applyAddress(val);
        },
    },
    computed: {
        ...mapState(["DaData"]),
        ...mapGetters(["noflat"]),
        addressValidation() {
            if (!this.client.object.address.text)
                return "";
            if (!this.client.object.address.house)
                return "Укажите полный адрес";
            return "";
        }
    },
    components: { TextInput, NumberInput }
}
</script>

<style lang="sass" scoped>

</style>